// Payment service for fetching payment processor configuration
import {fetchWithErrorHandling, guestPrefix} from './apiUtils';

export interface PaymentConfig {
  accountId: string;
  hashedKey: string;
}

export class PaymentService {
  /**
   * Get payment processor configuration for client-side tokenization.
   * Uses GET /api/v2/checkout/payment-config (authenticated) or /api/v2/guest/checkout/payment-config (guest).
   */
  static async getPaymentConfig(): Promise<PaymentConfig> {
    const endpoint = `/api/v2${guestPrefix()}/checkout/payment-config`;

    return await fetchWithErrorHandling<PaymentConfig>(endpoint, {
        method: 'GET',
    });
  }
}
